const FETCHING_COMMANDERS_TYPEAHEAD = "FETCHING_COMMANDERS_TYPEAHEAD";
const FETCHING_COMMANDERS_TYPEAHEAD_SUCCESS = "FETCHING_COMMANDERS_TYPEAHEAD_SUCCESS";
const FETCHING_PARTNERS_TYPEAHEAD = "FETCHING_PARTNERS_TYPEAHEAD";
const FETCHING_PARTNERS_TYPEAHEAD_SUCCESS = "FETCHING_PARTNERS_TYPEAHEAD_SUCCESS";
const FETCHING_TYPEAHEAD = "FETCHING_TYPEAHEAD";
const FETCHING_TYPEAHEAD_SUCCESS = "FETCHING_TYPEAHEAD_SUCCESS";

const initialState = {
  commandersTypeahead: [],
  isLoadingCommandersTypeahead: false,
  isLoadingPartnersTypeahead: false,
  isLoadingTypeahead: false,
  partnersTypeahead: [],
  typeahead: [],
};

const typeahead = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_COMMANDERS_TYPEAHEAD:
      return {
        ...state,
        isLoadingCommandersTypeahead: true,
      };
    case FETCHING_COMMANDERS_TYPEAHEAD_SUCCESS:
      return {
        ...state,
        commandersTypeahead: action.typeahead,
        isLoadingCommandersTypeahead: false,
      };
    case FETCHING_PARTNERS_TYPEAHEAD:
      return {
        ...state,
        isLoadingPartnersTypeahead: true,
      };
    case FETCHING_PARTNERS_TYPEAHEAD_SUCCESS:
      return {
        ...state,
        isLoadingPartnersTypeahead: false,
        partnersTypeahead: action.typeahead,
      };
    case FETCHING_TYPEAHEAD:
      return {
        ...state,
        isLoadingTypeahead: true,
      };
    case FETCHING_TYPEAHEAD_SUCCESS:
      return {
        ...state,
        isLoadingTypeahead: false,
        typeahead: action.typeahead,
      };
    default:
      return state;
  }
};

const fetchingCommandersTypeahead = () => ({ type: FETCHING_COMMANDERS_TYPEAHEAD });

const fetchingCommandersTypeaheadSuccess = (typeahead) => ({
  type: FETCHING_COMMANDERS_TYPEAHEAD_SUCCESS,
  typeahead,
});

const fetchingPartnersTypeahead = () => ({ type: FETCHING_PARTNERS_TYPEAHEAD });

const fetchingPartnersTypeaheadSuccess = (typeahead) => ({
  type: FETCHING_PARTNERS_TYPEAHEAD_SUCCESS,
  typeahead,
});

const fetchingTypeahead = () => ({ type: FETCHING_TYPEAHEAD });

const fetchingTypeaheadSuccess = (typeahead) => ({
  type: FETCHING_TYPEAHEAD_SUCCESS,
  typeahead,
});

export const fetchCommandersTypeahead = () => async (dispatch) => {
  dispatch(fetchingCommandersTypeahead());
  const res = await fetch("api/typeahead/?commanders");
  const json = await res.json();
  return dispatch(fetchingCommandersTypeaheadSuccess(json));
};

export const fetchPartnersTypeahead = () => async (dispatch) => {
  dispatch(fetchingPartnersTypeahead());
  const res = await fetch("/api/typeahead/?partners");
  const json = await res.json();
  return dispatch(fetchingPartnersTypeaheadSuccess(json));
};

export const fetchTypeahead = () => async (dispatch) => {
  dispatch(fetchingTypeahead());
  const res = await fetch("/api/typeahead/");
  const json = await res.json();
  return dispatch(fetchingTypeaheadSuccess(json));
};

export default typeahead;
